/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
/* eslint react/prop-types: 0 */
import React from 'react';
import { join } from 'ramda';
import RenderDetail from './RenderDetail';
function renderRootCause(rootCause) {
    var paths = rootCause.listOfPaths.map(function (path) {
        return React.createElement("span", { key: path, className: "nx-vulnerability-details__root-cause-path" }, path);
    });
    return (React.createElement("div", { key: join('', rootCause.listOfPaths) },
        paths,
        React.createElement("span", { className: "nx-vulnerability-details__root-cause-version-range" }, rootCause.versionRange)));
}
var RootCauseDetail = function RootCauseDetail(_a) {
    var rootCauses = _a.rootCauses;
    return rootCauses ? (React.createElement(RenderDetail, { title: "Root Cause" }, rootCauses.map(renderRootCause))) : null;
};
export default RootCauseDetail;
//# sourceMappingURL=RootCauseDetail.js.map